import React, { useEffect, useState } from "react";
import { Breadcrumb, Flex } from "antd";
const { Item } = Breadcrumb;
import { Link } from "react-router-dom";
import Overview from "./Overview";
import TemplatePerformance from "./TemplatePerformance";
import AllConversationsChart from "./charts/AllConversationsChart";
import { allConversationsData } from "../../../constant/insights";
import FreeConversationCharts from "./charts/FreeConversationCharts";
import TabCharts from "./charts/TabCharts";
import WhatsappInsightsHeader from "../../../components/whatsapp/WhatsappInsightsHeader";
import GxBreadCrumb from "../../../../../components/commonComponents/breadCrumb/GxBreadCrumb";
import { fetchWhatsappBusinessInsights } from "../../../../../reduxToolkit/channelSlice";
import { useDispatch } from "react-redux";
import { useAspSelector } from "../../../../../test/jest-redux-hooks";
import dayjs from "dayjs"; // Import dayjs library

const WhatsappBusinessInsights = () => {
  // const [dateRange, setDateRange] = React.useState({ start: null, end: null });
  const breadCrumbItems = [
    { label: "Channels" },
    { label: "Whatsapp" },
    {
      label: "Insights",
      link: "/user/channels/whatsapp/insights",
    },
  ];

  const dispatch = useDispatch();
  const { currentBrand } = useAspSelector((state) => state.app);
  const brandId = currentBrand?.brand_id;

  // fetch whatsapp business insights on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let start, end;

    if (params.get("startDate") && params.get("endDate")) {
      start = Math.floor(Number(params.get("startDate")) / 1000);
      end = Math.floor(Number(params.get("endDate")) / 1000);
    } else {
      const today = dayjs().endOf("day");
      const lastWeek = dayjs().subtract(6, "day").startOf("day");
      start = lastWeek.startOf("day").valueOf() / 1000;
      end = today.endOf("day").valueOf() / 1000;
      params.set("startDate", lastWeek.startOf("day").valueOf());
      params.set("endDate", today.endOf("day").valueOf());
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`,
      );
    }

    // setDateRange({ start, end });
    dispatch(
      fetchWhatsappBusinessInsights({
        brand_id: brandId,
        start_date: start,
        end_date: end,
        phone_numbers: [],
        countries: [],
      }),
    );
  }, [dispatch, brandId]);

  return (
    <Flex
      className="w-full h-full"
      id="selected_screenshot_element"
      vertical
      gap={12}
    >
      <div className="mb-4-">
        <GxBreadCrumb breadCrumbItems={breadCrumbItems || []} />
      </div>
      <WhatsappInsightsHeader />
      <Overview />
      <div className="w-full md:w-[99%] transition-all duration-300 ease-in-out">
        <TemplatePerformance />
      </div>
      <AllConversationsChart allConversationsData={allConversationsData} />
      <FreeConversationCharts allConversationsData={allConversationsData} />
      <TabCharts />
    </Flex>
  );
};

export default WhatsappBusinessInsights;
